const SvgItAutomation3 = (props) => (
  <>
    <defs>
      <clipPath id="a">
        <path fill="none" d="M1.04.56h192.58v192.2H1.04z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)">
      <circle cx={1.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={1.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={1.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={1.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={1.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={1.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={1.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={1.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={1.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={1.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={1.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={1.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={1.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={17.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={17.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={17.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={17.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={17.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={17.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={17.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={17.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={17.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={17.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={17.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={17.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={17.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={33.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={33.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={33.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={33.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={33.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={33.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={33.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={33.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={33.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={33.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={33.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={33.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={33.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={49.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={49.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={49.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={49.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={49.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={49.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={49.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={49.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={49.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={49.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={49.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={49.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={49.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={65.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={65.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={65.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={65.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={65.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={65.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={65.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={65.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={65.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={65.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={65.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={65.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={65.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={81.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={81.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={81.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={81.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={81.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={81.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={81.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={81.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={81.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={81.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={81.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={81.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={81.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={97.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={97.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={97.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={97.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={97.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={97.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={97.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={97.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={97.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={97.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={97.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={97.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={97.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={113.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={113.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={113.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={113.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={113.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={113.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={113.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={113.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={113.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={113.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={113.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={113.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={113.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={129.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={129.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={129.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={129.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={129.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={129.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={129.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={129.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={129.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={129.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={129.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={129.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={129.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={145.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={145.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={145.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={145.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={145.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={145.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={145.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={145.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={145.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={145.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={145.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={145.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={145.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={161.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={161.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={161.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={161.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={161.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={161.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={161.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={161.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={161.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={161.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={161.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={161.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={161.04} cy={0.03} r={1} fill={props.p20} />
      <circle cx={177.04} cy={192.76} r={1} fill={props.p20} />
      <circle cx={177.04} cy={176.7} r={1} fill={props.p20} />
      <circle cx={177.04} cy={160.64} r={1} fill={props.p20} />
      <circle cx={177.04} cy={144.57} r={1} fill={props.p20} />
      <circle cx={177.04} cy={128.51} r={1} fill={props.p20} />
      <circle cx={177.04} cy={112.45} r={1} fill={props.p20} />
      <circle cx={177.04} cy={96.39} r={1} fill={props.p20} />
      <circle cx={177.04} cy={80.33} r={1} fill={props.p20} />
      <circle cx={177.04} cy={64.27} r={1} fill={props.p20} />
      <circle cx={177.04} cy={48.21} r={1} fill={props.p20} />
      <circle cx={177.04} cy={32.15} r={1} fill={props.p20} />
      <circle cx={177.04} cy={16.09} r={1} fill={props.p20} />
      <circle cx={177.04} cy={0.03} r={1} fill={props.p20} />
    </g>
    <path fill={props.p20} d="M1.59 192.25h192l-96-96.36-96 96.36z" />
    <circle cx={1.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={17.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={17.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={33.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={33.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={33.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={49.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={49.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={49.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={49.04} cy={48.21} r={1} fill="#001d6c" />
    <circle cx={65.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={65.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={65.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={65.04} cy={48.21} r={1} fill="#001d6c" />
    <circle cx={65.04} cy={32.15} r={1} fill="#001d6c" />
    <circle cx={81.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={81.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={81.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={81.04} cy={48.21} r={1} fill="#001d6c" />
    <circle cx={81.04} cy={32.15} r={1} fill="#001d6c" />
    <circle cx={81.04} cy={16.09} r={1} fill="#001d6c" />
    <circle cx={97.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={97.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={97.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={97.04} cy={48.21} r={1} fill="#001d6c" />
    <circle cx={97.04} cy={32.15} r={1} fill="#001d6c" />
    <circle cx={97.04} cy={16.09} r={1} fill="#001d6c" />
    <circle cx={97.04} cy={0.03} r={1} fill="#001d6c" />
    <circle cx={113.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={113.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={113.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={113.04} cy={48.21} r={1} fill="#001d6c" />
    <circle cx={113.04} cy={32.15} r={1} fill="#001d6c" />
    <circle cx={113.04} cy={16.09} r={1} fill="#001d6c" />
    <circle cx={129.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={129.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={129.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={129.04} cy={48.21} r={1} fill="#001d6c" />
    <circle cx={129.04} cy={32.15} r={1} fill="#001d6c" />
    <circle cx={145.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={145.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={145.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={145.04} cy={48.21} r={1} fill="#001d6c" />
    <circle cx={161.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={161.04} cy={80.33} r={1} fill="#001d6c" />
    <circle cx={161.04} cy={64.27} r={1} fill="#001d6c" />
    <circle cx={177.04} cy={96.39} r={1} fill="#001d6c" />
    <circle cx={177.04} cy={80.33} r={1} fill="#001d6c" />
  </>
);

export default SvgItAutomation3;
